import React, { useEffect, Component } from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
import { caseStudies } from '../data/caseStudies';
export function CaseStudyPage() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const study = caseStudies.find(s => s.id === id);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);
  if (!study) {
    return <Navigate to="/work" replace data-id="element-98" />;
  }
  return <div className="max-w-4xl mx-auto px-6 pt-24 pb-24" data-id="element-99">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} data-id="element-100">
        <Link to="/work" className="inline-flex items-center gap-2 text-sm font-medium text-gray-500 hover:text-black mb-12 transition-colors" data-id="element-101">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-102" /> Back to Work
        </Link>

        {/* Hero */}
        <div className="mb-16" data-id="element-103">
          <h1 className="text-4xl md:text-6xl font-bold tracking-tight mb-6" data-id="element-104">
            {study.title}
          </h1>
          <p className="text-2xl text-gray-600 leading-snug max-w-3xl mb-12" data-id="element-105">
            {study.subtitle}
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 py-8 border-y border-gray-100" data-id="element-106">
            <div data-id="element-107">
              <div className="text-sm text-gray-400 uppercase tracking-wider font-semibold mb-2" data-id="element-108">
                Role
              </div>
              <div className="font-medium" data-id="element-109">{study.role}</div>
            </div>
            <div data-id="element-110">
              <div className="text-sm text-gray-400 uppercase tracking-wider font-semibold mb-2" data-id="element-111">
                Timeline
              </div>
              <div className="font-medium" data-id="element-112">{study.timeline}</div>
            </div>
            {study.metrics.map((metric, i) => <div key={i} data-id="element-113">
                <div className="text-sm text-gray-400 uppercase tracking-wider font-semibold mb-2" data-id="element-114">
                  {metric.label}
                </div>
                <div className="font-bold text-xl" data-id="element-115">{metric.value}</div>
              </div>)}
          </div>
        </div>

        {/* Summary */}
        <div className="text-lg leading-relaxed text-gray-700 mb-16 font-medium max-w-3xl" data-id="element-116">
          {study.description}
        </div>

        {/* Sections */}
        <div className="space-y-0" data-id="element-117">
          {study.sections.map((section, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5
        }} className={`py-12 px-8 -mx-8 rounded-2xl ${index % 2 === 1 ? 'bg-gray-50' : 'bg-white'}`} data-id="element-118">
              <h2 className="text-2xl font-bold tracking-tight mb-6 text-black" data-id="element-119">
                {section.title}
              </h2>
              <ul className="space-y-3" data-id="element-120">
                {section.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-3 text-gray-700 leading-relaxed" data-id="element-121">
                    <span className="w-1.5 h-1.5 rounded-full bg-black mt-2.5 shrink-0" data-id="element-122" />
                    <span data-id="element-123">{bullet}</span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>

        {/* Back link */}
        <div className="mt-16 pt-8 border-t border-gray-100" data-id="element-124">
          <Link to="/work" className="inline-flex items-center gap-2 text-sm font-medium text-gray-500 hover:text-black transition-colors" data-id="element-125">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-126" /> Back to Work
          </Link>
        </div>
      </motion.div>
    </div>;
}